const STORY_CHEST_COLLISION_WIDTH = 24;
const STORY_CHEST_COLLISION_HEIGHT = 10;
const STORY_CHEST_COLLISION_BOTTOM_INSET = 10;

export const getStoryChestCollisionRect = (chest = {}, spriteRect = {}) => {
  const chestX = Number(chest.x || 0);
  const chestY = Number(chest.y || 0);
  const spriteWidth = Number(spriteRect.width || 0);
  const spriteHeight = Number(spriteRect.height || 0);

  return Object.freeze({
    x: chestX + spriteWidth / 2,
    y:
      chestY +
      spriteHeight -
      STORY_CHEST_COLLISION_BOTTOM_INSET -
      STORY_CHEST_COLLISION_HEIGHT / 2,
    width: Math.min(STORY_CHEST_COLLISION_WIDTH, spriteWidth),
    height: Math.min(STORY_CHEST_COLLISION_HEIGHT, spriteHeight),
  });
};

export const getStoryChestInteractionRect = (chest = {}, spriteRect = {}) => {
  const chestX = Number(chest.x || 0);
  const chestY = Number(chest.y || 0);
  const spriteWidth = Number(spriteRect.width || 0);
  const spriteHeight = Number(spriteRect.height || 0);

  return Object.freeze({
    x: chestX + spriteWidth / 2,
    y: chestY + spriteHeight / 2,
    width: spriteWidth + 12,
    height: spriteHeight + 10,
  });
};

export const createStoryChestBodies = (
  scene,
  chest,
  spriteRect,
  { isOpened = false } = {},
) => {
  const collisionRect = getStoryChestCollisionRect(chest, spriteRect);
  const interactionRect = getStoryChestInteractionRect(chest, spriteRect);
  const collisionBody = scene.matter.add.rectangle(
    collisionRect.x,
    collisionRect.y,
    collisionRect.width,
    collisionRect.height,
    {
      isStatic: true,
      label: `chest-collision:${chest.id}`,
    },
  );
  const interactionBody = isOpened
    ? null
    : scene.matter.add.rectangle(
        interactionRect.x,
        interactionRect.y,
        interactionRect.width,
        interactionRect.height,
        {
          isStatic: true,
          isSensor: true,
          label: `chest:${chest.id}`,
        },
      );

  return { collisionBody, interactionBody };
};
